<a (click)="clickEvent.emit($event)" [href]="href" [ngClass]="linkClasses">
  <span class="d-inline-flex align-items-center justify-content-center">{{
    label
  }}</span>
</a>
